export default "__VITE_ASSET__BUVaVTbe__"